import type { EditFixtureForm, FixtureUpsert } from "~pages/Fixtures/types";

export const getFixtureSubmitData = (values: EditFixtureForm): FixtureUpsert => ({
  attendance: values.attendance ? +values.attendance : null,
  externalId: values.externalId || null,
  fixtureNumber: values.fixtureNumber ? +values.fixtureNumber : null,
  internationalReference: values.internationalReference || null,
  includeInStandings: values.includeInStandings,
  liveDataAvailable: values.liveDataAvailable,
  nameLatin: values.nameLatin || null,
  nameLocal: values.nameLocal || null,
  placingIfLost: values.placingIfLost ? +values.placingIfLost : null,
  placingIfWon: values.placingIfWon ? +values.placingIfWon : null,
  poolCode: values.poolCode?.value || null,
  profileId: values.profileId?.value || null,
  sellout: values.sellout,
  seriesCode: values.seriesCode?.value || null,
  stageCode: values.stageCode?.value || null,
  status: values.status,
  ticketURL: values.ticketURL || null,
  timesUnconfirmed: values.timesUnconfirmed,
});
